///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

const getPropertyName = name => {
  var propertyName;
  switch (name) {
    case "hrhv":
      propertyName = "HRHV";
      break;
    case "mxCost":
      propertyName = "MXCost";
      break;
    case "mxMiles":
      propertyName = "MXMiles";
      break;
    case "adr":
      propertyName = "ADR";
      break;
    case "rxousatttCost":
      propertyName = "RXOUSATTTCost";
      break;
    case "pwbMargin":
      propertyName = "PWBMargin";
      break;
    default:
      propertyName = name.charAt(0).toUpperCase() + name.slice(1);
  }
  return propertyName;
};

export const bindEditedLanes = state => {
  const requestLaneEdits = [];
  const editedLanes = state.lanes.filter(l => l.metaData.laneChanged === true);

  editedLanes.map(l => {
    var changedProps = Object.keys(l.metaData.originaLane).filter(
      k => l.metaData.originaLane[k] !== l[k]
    );
    changedProps.map(k =>
      requestLaneEdits.push({
        laneId: l.truckloadLaneId,
        propertyName: getPropertyName(k),
        value: l[k],
        isCalculated: !(
          l.metaData.change[k] && l.metaData.changedByUserValue[k] === l[k]
        )
      })
    );
    return requestLaneEdits;
  });
  return requestLaneEdits;
};

export default bindEditedLanes;
